
  <mat-card class="my-card">
   <form [formGroup]="loginForm" class="example-container">
     <mat-card-content>
           <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email</mat-label>
              <input  matInput type="email" placeholder="Email" id="userEmail" formControlName="userEmail"  class="form-control" required>
            <mat-error *ngIf="userEmail.invalid && (userEmail.dirty || userEmail.touched)">
            {{getEmailErrorMessage()}}
            </mat-error>
           </mat-form-field>

           <mat-form-field appearance="outline" class="full-width">
              <mat-label>Password </mat-label><a style="float: right;" [routerLink]="['/resetPassword']">Forgot Password?</a>
              <input  matInput type="password" placeholder="Password" id="userPassword" formControlName="userPassword" class="form-control" required>
              <mat-error *ngIf="userPassword.invalid && (userPassword.dirty || userPassword.touched)">
         {{getPasswordErrorMessage()}}
              </mat-error>
            </mat-form-field>
     
     </mat-card-content>
     <mat-card-actions>
         <button mat-raised-button (click)="login()" color="primary">LOGIN</button>
         <button mat-button (click)="register()" color="accent">Not a user, click here to Register!</button>
     </mat-card-actions>
      </form>
  </mat-card>

<!-- <div *ngIf="dialog">
  <dialog-overview-example [message]="message"></dialog-overview-example>
</div> -->